export default {
  methods: {
    setColor(value, override = null) {
      const target = (value || {}).color ? value.color : value
      return override || target
    },
  },
}
